import { RouteConfig } from 'vue-router';
import { AmDashboardRoutes } from '../amDashboard/routes';
import { FundRoutes } from '../fund/routes';
import { PensionSchemeRoutes } from '../pensionScheme/routes';
import { UserRoutes } from '../user/routes';
import { SubFundRoutes } from '../subFund/routes';
import { AssociateUserRoutes } from '../associateUser/routes';
import { ForecastModuleRoutes } from '../forecast/routes';
import { MrtRoutes } from '../machineReadableTemplate/routes';

const InvestmentModule = () =>
  import(
    /* webpackChunkName: 'investment' */ '@/modules/investment/InvestmentModule.vue'
  );

export const InvestmentRoutes: RouteConfig[] = [
  {
    path: 'manage',
    component: InvestmentModule,
    props: true,
    name: 'dashboard.organisation.investments',
    children: [
      ...FundRoutes,
      ...PensionSchemeRoutes,
      ...AmDashboardRoutes,
      ...UserRoutes,
      ...SubFundRoutes,
      ...AssociateUserRoutes,
      ...ForecastModuleRoutes,
      ...MrtRoutes
    ]
  }
];
